import { cn } from "@quortex/front-common"
import type { FC } from "react"

interface DisableModalContentProps {
  segmentChildren: string[]
  isRootSegment?: boolean
  name: string
  restSegmentName?: string
  parentSegmentName?: string
  isLastSegment?: boolean
}

const DeleteSegmentContent: FC<DisableModalContentProps> = ({
  name,
  segmentChildren,
  isLastSegment,
  restSegmentName,
  parentSegmentName,
  isRootSegment
}) => (
  <ul className={cn(isLastSegment && !isRootSegment && "ml-md list-disc")}>
    <li>
      Balancing configuration for <strong>{name}</strong>
      {segmentChildren.length > 0 ? " and all subsegments" : ""} will be lost.
    </li>
    {isLastSegment && !isRootSegment && (
      <li>
        Balancing configuration for <strong>{restSegmentName}</strong> will be transferred to{" "}
        <strong>{parentSegmentName}</strong>.
      </li>
    )}
  </ul>
)

export default DeleteSegmentContent
